import { create } from 'zustand'

export type ThemeMode = 'auto' | 'dark' | 'light'
export type PerfMode = 'full' | 'balanced' | 'lite'

interface UiStore {
  theme: ThemeMode
  perf: PerfMode
  setTheme: (t: ThemeMode) => void
  setPerf: (p: PerfMode) => void
}

function load<T extends string>(key: string, fallback: T): T {
  try {
    return (localStorage.getItem(key) as T) || fallback
  } catch {
    return fallback
  }
}
function save(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    /* storage disabled */
  }
}

export const useUiStore = create<UiStore>((set) => ({
  theme: load<ThemeMode>('ui_theme', 'auto'),
  perf: load<PerfMode>('ui_perf', 'full'),
  setTheme: (theme) => {
    save('ui_theme', theme)
    set({ theme })
  },
  setPerf: (perf) => {
    save('ui_perf', perf)
    set({ perf })
  },
}))
